export default class GeneralDataRepository {
  save(generaData) { }
  get() { }
}